module.exports = __webpack_public_path__ + "static/media/get_started_1.855f8ad2.png";